import React, { memo, useContext, useState } from 'react';
import 'react-tooltip/dist/react-tooltip.css'
import getTailwindBgColor from '../getTailwindBgColor';

function DiagramHeader({ id, data }) {

    return (
        <div className={`border-b-2 w-[210px] h-14 flex justify-center items-center`}>
            <strong className='truncate text-gray-200'>{id}</strong>
        </div>
    );
}

export default memo(DiagramHeader);
